import { render, staticRenderFns } from "./CollapsableDestination.vue?vue&type=template&id=26fc0c53&scoped=true&"
import script from "./CollapsableDestination.vue?vue&type=script&lang=js&"
export * from "./CollapsableDestination.vue?vue&type=script&lang=js&"
import style0 from "./CollapsableDestination.vue?vue&type=style&index=0&id=26fc0c53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fc0c53",
  null
  
)

export default component.exports